/**
 * Created by cc on 2016/9/23 0023.
 */
'use strict';
import mysql from 'mysql';

import tool from '../util/toolkit';


let POOL = {};
let DefaultPool = false;

export default  {
    get : async function(name = false){
        if(name === false){
            if(DefaultPool !== false){
                return await tool.P(DefaultPool.getConnection,DefaultPool)();
            }
        }
        if(POOL[name] !== undefined){
            return await tool.P(POOL[name].getConnection,POOL[name])();
        }
        return false;
    },
    set : async function({host = 'localhost', port = 3306, user = false, password = false, database = false,name = false} = {}) {
        let APOOL = mysql.createPool({
            host: host,
            port: port,
            user: user,
            password: password,
            database: database,
            multipleStatements : true
        });
        if(name === false){
            if(DefaultPool !== false){
                await tool.P(DefaultPool.end,DefaultPool)();
            }
            DefaultPool = APOOL;
        }else{
            POOL[name] = APOOL;
        }
        return this;
    }
}
module.exports = exports.default;